import { Methodology } from '../types';

export const methodology: Methodology = {
  title: "Metodologia",
  description: "Nossa abordagem metodológica combina análise teórica rigorosa com implementações computacionais avançadas para reexaminar as teorias fundamentais da física.",
  steps: [
    {
      title: "Pesquisa bibliográfica",
      description: "Revisão da literatura científica mais recente sobre cada teoria."
    },
    {
      title: "Reformulação matemática",
      description: "Desenvolvimento de equações usando notação matemática moderna."
    },
    {
      title: "Implementação computacional",
      description: "Criação de modelos computacionais para simular e visualizar os fenômenos físicos."
    },
    {
      title: "Análise crítica",
      description: "Identificação de inconsistências, lacunas e limitações em cada teoria."
    },
    {
      title: "Integração interdisciplinar",
      description: "Exploração das conexões entre diferentes teorias."
    }
  ]
};